<script>
    import {deletePhotoById, updatePhotoCaption, writePhotoToFireStore} from "../../config/database-repo";
    import {album} from "../photos/photo-store";
    import TextInput from "../../components/ui/TextInput.svelte";
    import Form from "../../components/ui/Form.svelte";
    import Button from "../../components/ui/Button.svelte";
    import AlertMessage from "../../components/ui/AlertMessage.svelte";
    import Modal from "../../components/ui/Modal.svelte";

    let files, fileInputRef;

    let caption;
    let message;
    let selected = null;
    let confirmModalOpen = false;
    $: isFormValid = caption?.length > 3 && files && files[0];

    function onCaptionChange({target: {value}}) {
        caption = value;
    }

    function onCaptionUpdate({target : {value}}) {
        selected.alt = value;
    }

    const savePhoto = async () => {
        message = await writePhotoToFireStore(files[0], caption);
        clearForm();
    };

    const clearForm = () => {
        caption = '';
        fileInputRef.value = '';
    };

    const deletePhoto = async () => {
        message = await deletePhotoById(selected.id);
        $album = $album.filter(item => item.id !== selected.id);
        confirmModalOpen = false;
        selected = null;
    }

    const updatePhoto = async () => {
        message = await updatePhotoCaption(selected.id, selected.alt);
    }

    function toggleModal() {
        confirmModalOpen = !confirmModalOpen;
    }
</script>

<!--------------------------------------------------------------------------------------------------------------------->
<AlertMessage {message} />

{#if selected}
    <Form name="Photo: {selected.id}">
        <img src={selected.src} alt={selected.alt} />
        <TextInput label="Change caption" value={selected.alt} on:input={onCaptionUpdate}/>

        <svelte:fragment slot="btns">
            <Button clazz="add" on:click={() => {selected = null}}>close</Button>
            <Button clazz="delete" on:click={toggleModal}>delete</Button>
            <Button clazz="submit" on:click={updatePhoto} type="submit">update</Button>
        </svelte:fragment>
    </Form>
{:else}
    <Form name="New Photo" disabled={!isFormValid} on:clear={clearForm} on:submit={savePhoto}>
        <div class="form-control">
            <label for="photo">Choose a photo</label>
            <input type="file" id="photo" accept="image/*" bind:files bind:this={fileInputRef}>
            {#if fileInputRef?.value}<img src={URL.createObjectURL(files[0])} alt="kok" class="previewImg">{/if}
        </div>
        <TextInput label="caption" value={caption} on:input={onCaptionChange}/>
    </Form>
{/if}

<section class="album">
    {#each $album as photo (photo.id)}
        <figure class="aphoto" class:active={photo.id === selected?.id}>
            <img src={photo.src} alt={photo.alt} on:click={() => {selected = photo}}/>
            <figcaption>{photo.alt}</figcaption>
        </figure>
    {/each}
</section>

{#if confirmModalOpen}
    <Modal on:close={toggleModal}>
        <Form name="Confirm Delete of: {selected.alt}">
            <svelte:fragment slot="btns">
                <Button clazz="add" on:click={toggleModal}>close</Button>
                <Button clazz="delete" on:click={deletePhoto}>delete</Button>
            </svelte:fragment>
        </Form>
    </Modal>
{/if}
<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .form-control {
        padding-bottom: .8rem;
        position: relative;
        min-height: 70px;
    }
    .form-control > label{
        font-weight: bold;
        padding: 3px;
    }
    .form-control > input {
        display: block;
        width: 100%;
        border-radius: 6px;
        padding: 2px 3px;
        font-size: 1rem;
    }
    .previewImg {
        display: inline;
        width: 100px;
        height: 67px;
        position: absolute;
        left: 300px;
        top: 0;
    }
    /* ---------------------------- */

    .album {
        margin: 2rem 0;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }
    .aphoto {
        height: 110px;
        margin: .5rem;
        border-bottom: 2px solid var(--black-color);
        flex-basis: 250px;
        flex-grow: 1;
    }

    img {
        height: 80px;
    }

    .active {
        border: 2px solid var(--black-color);
    }
</style>